<div class="grid grid-cols-1 md:grid-cols-3 gap-4">
	<mat-card
		*ngFor="let group of groups"
		class="flex justify-between gap-4 p-6 cursor-pointer transition-all duration-200 shadow-none border rounded-lg"
		[class.ring-2]="isSelected(group.id)"
		[class.ring-primary]="isSelected(group.id)"
		[class.bg-primary-50]="isSelected(group.id)"
		[matTooltip]="group.description"
		(click)="toggleGroup(group.id)">


		<mat-card-content class="flex gap-3 justify-between items-center">

			<mat-icon
				[svgIcon]="isSelected(group.id) ? 'heroicons_outline:check-circle' : group.icon"
				class="text-lg leading-none"
				[class.text-accent]="!isSelected(group.id)"
				[class.text-primary]="isSelected(group.id)">
			</mat-icon>

			<h3 class="text-md font-semibold leading-none">{{ group.name }}</h3>
			<!-- <p class="text-sm text-gray-600">{{ group.description }}</p> -->
		</mat-card-content>

	</mat-card>
</div>
